import Footnotes from './Footnotes';

const footnotesConfig = {
  name: 'footnotes',
  class: Footnotes,
  querySelectorAll: {
    footnote: '.footnotes__list-item',
  },
};

export default footnotesConfig;



// WEBPACK FOOTER //
// ./client/js/components/Footnotes/footnotesConfig.js